import React, { useState, useEffect } from "react"
import Collapse from "@material-ui/core/Collapse"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import IconButton from "@material-ui/core/IconButton"
import { getCardIcon } from "../../utils/utils"
import { useTranslation } from "react-i18next"
import { InquiryTable } from './InquiryTable/InquiryTable'

export const InquiriesCard = (props) => {

    const { t } = useTranslation()


    const [expanded, setExpanded] = useState(false)
    const [firstTime, setFirstTime] = useState(true)

    const { inquiries, isPDF } = props

    let initialExpand = inquiries.has_inquiries

    if (initialExpand !== expanded && firstTime === true) {
        setExpanded(initialExpand)
    }

    const handleExpand = (event) => {
        event.stopPropagation()
        setFirstTime(false)
        setExpanded(!expanded)
    }

    useEffect(()=>{
        if(isPDF){
            setExpanded(true)
        }
    }, [isPDF])

    return (
        <div className="avoidPageBreakInside analysisCard">
            <div style={{ display: "flex" }}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{ margin: "auto 0px" }}
                >
                    {t("Consultas")}
                </div>
                <div style={{ margin: "auto 10px" }}>
                    {getCardIcon(inquiries.has_inquiries)}
                </div>
                {!isPDF&&inquiries.details?.length > 0 &&
                    <IconButton style={{ marginLeft: "auto" }} onClick={handleExpand}>
                        {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                }
            </div>
            {inquiries.details?.length > 0 &&
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div
                        className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                    >
                        <InquiryTable inquiries={inquiries} />
                    </div>
                </Collapse>
            }
        </div>
    )
}
